/**
 * Created by odeds on 12/29/15.
 * This model is used for displaying APIs list in API tab in data source and in creating new API keys page, in the section where you select APIs.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    //needed to return the checkbox state enum
    var Checkbox = require("ui/checkbox/Checkbox");
    var LocaleResolver = require("i18n/localeResolver");
    var ApiKeyListModel = {};

    var FetchState = {
        NONE:     "none",
        ERROR:    "error",
        SUCCESS:  "success",
        LOADING:  "loading"
    };

    var NAME = "ApiFullListModel";

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeyListModel = BaseModel.extend({
            resource: ApiResources.ApiKeyManager.ApiFullList,
            name: NAME,
            initialize: function (options) {
                BaseModel.prototype.initialize.call(this, options);
            },

            fetch: function(options) {
                options = options || {};

                // First Check if we need to validate the freshness of the data.
                // * If not fresh enough, it continues processing the fetch
                // * If data is fresh, it will call the success callback immediately
                // * If no need for freshness, it continues processing the fetch
                var freshnessTime = _.has(options, "freshnessTime") ? options.freshnessTime : this.freshnessTime;
                if (freshnessTime && this.hasAtLeastOneSuccessfulFetch() && freshnessTime > (new Date().getTime()) - this.getLastFetchSuccess()) {
                    options.success(this, {}, options);
                    return;
                }

                //todo Noam to move to base model
                var successFunc = options.success;
                var errorFunc = options.error;

                options.success = function(model, response, options) {
                    model.setFetchState(FetchState.SUCCESS);
                    if (_.isFunction(successFunc)) {
                        successFunc(model, response, options);
                    }
                };
                options.error = function(model, response, options) {
                    model.setFetchState(FetchState.ERROR);
                    if (_.isFunction(errorFunc)) {
                        errorFunc(model, response, options);
                    }
                };

                this.setFetchState(FetchState.LOADING);

                return BaseModel.prototype.fetch.call(this, options);
            },

            parse: function(response, options){
                LEManager.logger.debug("enter function", "ApiKeyListModel:parse");
                var languinoPrefixForApiKeys = "LEManager.manager.dataSources.Api_Keys.data.";
                try{
                    response.groups = _.filter(response.groups, function(group) { //Filters out of the response any group for which we don't have a key in Languino and adds translated group name property.
                        if (LE.translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), languinoPrefixForApiKeys + group.groupName)) {
                            group.groupName_translated= LE.translator.translate(languinoPrefixForApiKeys+ group.groupName);
                            this._parseApis(group, languinoPrefixForApiKeys);
                            return group.apis.length >= 1;
                        } else {
                            return false;
                        }
                    }, this);
                    //newCol boolean property is being added per each group, it determines if the group will be displayed in a new column or not
                    //(two groups per column)
                    _.each(response.groups, function(group) {
                        var groupIndex = _.indexOf(response.groups, group);
                        group.newCol= groupIndex%2 === 0;
                    });
                    return response;
                }catch(e){
                    var error = options.error;
                    this.setFetchState(FetchState.ERROR);
                    LEManager.logger.error("Error parsing API key list from response. " + e,"ApiKeyListModel:parse");
                    LEManager.logger.graph({name: "manager:ApiKeyListModel:parse:exception"});
                    error(this, e);
                }
            },
            /**
             * Parses all apis per group: filters out the apis for which a languino key is missing and adds properties per each.
             * Throws an exception if the data of the api is not structured in an array.
             * @param group The group for which apis should be parsed
             * @param languinoPrefix The languino key prefix for the api name
             * @private
             */
            _parseApis: function(group, languinoPrefix) {
                group.apis = _.filter(group.apis, function(api) { //Filters out of the group any api for which we don't have a key in Languino.
                    api.apiName = api.apiName.toLowerCase().replace(/[.-\s]/g, "_");
                    if (LE.translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), languinoPrefix + api.apiName)) {
                        api.enabled= api.type === "api";
                        api.apiName_translated= LE.translator.translate(languinoPrefix + api.apiName);
                        if(!_.isArray(api.data)){ //The data is used in adding new API keys page and crucial for its apis display, therefore an exception is thrown in case of wrong format
                            throw "No keys returned for " + api.apiName;
                        }
                        return true;
                    } else {
                        return false;
                    }
                });
            },

            hasKey: function(queryKey){
                LEManager.logger.debug("check whether key specified is selected", "ApiKeyListModel:hasKey");
                var isSelected= false;

                this._traverseOverAPIs(function(api){
                    var keysLength = api.data.length;
                    for (var k = 0; k < keysLength; k++) {
                        var key= api.data[k];
                        if(queryKey === key.key){
                            isSelected= key.selected || false;
                            return true;
                        }
                    }
                });

                return isSelected;
            },

            getState: function() {
                LEManager.logger.debug("get a flat list of privileges", "ApiKeyListModel:getState");
                var privileges= [];

                this._traverseOverAPIs(function(api){
                    var keysLength = api.data.length;
                    for (var k = 0; k < keysLength; k++) {
                        var key= api.data[k];
                        var type= key.type || "API";
                        if(key.selected){
                            privileges.push({"type": type, "data": key.key});
                        }
                    }
                });

                return privileges;
            },

            /**
             * Parses into the model the selected state. from flat list to the canonical model.
             * @param state    a flat array of objects having the key set in the data attribute and type attribute which is usually equal to "api"
             */
            setState: function(state) {
                LEManager.logger.debug("build internal canonical state off a flat list of privileges", "ApiKeyListModel:setState");
                if(_.isArray(state)){
                    this._clearAllSelected();

                    var arrayLength = state.length;
                    for (var i = 0; i < arrayLength; i++) {
                        var key= state[i];
                        this.updateKey(key.data, true);
                    }
                }
            },

            factory: function(state){
                var clone= this.clone();
                clone.setState(state);
                return clone;
            },

            updateKey: function(queryKey, value){
                LEManager.logger.debug("mark a given privilege its selection value", "ApiKeyListModel:updateKey");

                this._traverseOverAPIs(function(api){
                    var keysLength = api.data.length;
                    for (var k = 0; k < keysLength; k++) {
                        var key= api.data[k];
                        if(key.key === queryKey){
                            key.selected= value;
                            return true;
                        }
                    }
                });

            },

            updateAPI: function(queryAPI, value){
                LEManager.logger.debug("mark a given api and it's children privileges its selection value", "ApiKeyListModel:updateAPI");

                this._traverseOverAPIs(function(api){
                    // apply value to api and it's child privileges if api matches queryAPI param
                    if(api.apiName === queryAPI){
                        var keysLength = api.data.length;
                        for (var k = 0; k < keysLength; k++) {
                            var key= api.data[k];
                            key.selected= value;
                        }
                        return true;
                    }
                });

            },

            /**
             * reset all selection to false due to shallow copy
             * @private
             */
            _clearAllSelected: function(){
                LEManager.logger.debug("reset all selection to false", "ApiKeyListModel:_clearAllSelected");

                this._traverseOverAPIs(function(api){
                    var keysLength = api.data.length;
                    for (var k = 0; k < keysLength; k++) {
                        var key= api.data[k];
                        key.selected= false;
                    }
                });

            },

            /**
             *   query an api's checkbox value
             * @param queryAPI
             * @returns {Checkbox.STATES}
             */
            getApiState: function(queryAPI){
                LEManager.logger.debug("query an api's checkbox value", "ApiKeyListModel:getApiState");
                var cbValue= Checkbox.STATES.MIDCHECKED;

                this._traverseOverAPIs(function(api){
                    if(api.apiName === queryAPI){
                        var selected= 0;
                        var keysLength = api.data.length;
                        for (var k = 0; k < keysLength; k++) {
                            var key= api.data[k];
                            if(key.selected){
                                ++selected;
                            }
                        }
                        switch(selected){
                            case 0:
                                cbValue= Checkbox.STATES.UNCHECKED;
                                break;
                            case keysLength:
                                cbValue= Checkbox.STATES.CHECKED;
                                break;
                        }
                        return true;
                    }
                });

                return cbValue;
            },

            _traverseOverAPIs: function(callback){
                LEManager.logger.debug("generic internal function to call callback on each api", "ApiKeyListModel:_traverseOverAPIs");
                var groups= this.get("groups");

                //loop through groups
                var groupsLength = groups.length;
                for (var i = 0; i < groupsLength; i++) {
                    var group= groups[i];

                    // loop on each group's apis
                    var apisLength = group.apis.length;
                    for (var j = 0; j < apisLength; j++) {
                        var api= group.apis[j];

                        // do your magic and break the loop if callback returns true
                        if(callback(api)){
                            return;
                        }
                    }
                }
            },

            /**
             * In the case apikeys are returned along with legacy privileges that are
             * not listed in ApiKeyListModel. This function will initialize a member of this model
             * that is the flat version of privileges, against which the keys would be searched.
             * Keys that are not contained will be returned for later preservation when
             * updating backend entity.
             * @param keys flat array of privileges objects with the privilege in each object's data attribute
             */
            getUnlistedKeys: function(keys){
               //create a flat list of listed keys
               //return an array of unlisted keys that are in the keys param
            },
            setFetchState: function(state) {
                this.fetchState = state;
                this.trigger("fetch:" + state);
            },

            getFetchState: function(){
                return this.fetchState;
            }



        });
    });

    ApiKeyListModel.FetchState = FetchState;
    ApiKeyListModel.NAME = NAME;

    return ApiKeyListModel;
});

